import styled from 'styled-components';

import ReactTooltip from 'react-tooltip';
import {
  Box, Text, TextInput, Button,
} from 'grommet';

const StyledStatusBadge = styled(Box)`
  text-align: center;
  polyline { stroke-width: 3px; }
  border-radius: var(--app-radius);
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  height: fit-content;
  min-width: fit-content;

  @media (max-width: 768px) {
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    max-height: 2.25rem;
  }
`;

const StyledTextInput = styled(TextInput)`
  background: var(--page-input-bg);
  font-size: 0.8rem;
  border: solid 1px var(--page-input-border);
  padding: 0.4rem 0.6rem;
  border-radius: var(--app-radius);
  width: 100%;

  &:focus {
    border-color: ${({ focusHighlight }) => focusHighlight};
  }
`;

const StyledTooltip = styled(ReactTooltip)`
  font-family: inherit;
  border-radius: 6px;
`;

const StyledHoverText = styled(Text)`
  &:hover {
    cursor: pointer;
    color: ${({ hoverColor }) => hoverColor};
  }
`;

const StyledSeeDetailsButton = styled(Button)`
  color: ${({ textColor }) => textColor};

  &:hover {
    color: ${({ hoverTextColor }) => hoverTextColor};

    div > span {
      color: ${({ hoverTextColor }) => hoverTextColor};
    }

    svg {
      fill: ${({ hoverTextColor }) => hoverTextColor};

      path, rect {
        fill: ${({ hoverTextColor }) => hoverTextColor};
      }
    }
  }
`;

export {
  StyledStatusBadge,
  StyledTextInput,
  StyledTooltip,
  StyledHoverText,
  StyledSeeDetailsButton,
};
